import { useMemo } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import { PWAInstallElement } from '@khmyznikov/pwa-install';
import {
  getPWAInstallInstructions,
  isPWAInstalled,
} from '../../../utils/getPWAInstallInstructions';
import { useSnackbar } from 'notistack';

const InstallPWA = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleShowDialog = () => {
    const pwaInstall = document.getElementsByTagName('pwa-install')[0] as
      | PWAInstallElement
      | undefined;

    if (pwaInstall) {
      pwaInstall.showDialog();
    }
  };

  const isInstalled = isPWAInstalled();

  const isInstallAvailable = useMemo(() => {
    if (isInstalled) return false;

    const pwaInstall = document.getElementsByTagName('pwa-install')[0] as
      | PWAInstallElement
      | undefined;

    if (pwaInstall) {
      return (
        pwaInstall.isInstallAvailable ||
        pwaInstall.isAppleMobilePlatform ||
        pwaInstall.isAppleDesktopPlatform ||
        pwaInstall.isAndroidFallback
      );
    }
    return false;
  }, [isInstalled]);

  const handleInstallClick = async () => {
    if (isInstallAvailable) {
      handleShowDialog();
    } else {
      const instructions = await getPWAInstallInstructions();
      enqueueSnackbar(instructions, {
        variant: 'info',
        title: 'Info',
      });
    }
  };

  if (isInstalled) {
    // Don't shiow if the app is installed
    return null;
  }

  return (
    <ListItem disablePadding>
      <ListItemButton
        color={isInstallAvailable ? 'success' : 'error'}
        onClick={handleInstallClick}
      >
        <ListItemIcon>
          <GetAppIcon />
        </ListItemIcon>
        <ListItemText primary={'Install App'} />
      </ListItemButton>
    </ListItem>
  );
};

export default InstallPWA;
